import { Box, Button, IconButton, Skeleton, Typography } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import veg from "../Assets/product_management/Foodmark.svg"
import nonVeg from "../Assets/product_management/non-veg.svg"
import { useState } from "react";
import { useEffect } from "react";
import { useDateformate, useGetOffers } from "../Components/globalFunctions";
import Tooltip from '@mui/material/Tooltip';
import CustomAxios from "../utils/CustomAxios";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { updateOfferDetail, updateOfferEdit, updateOfferModal, updateOffers } from "../Redux/offers";

export function OffersTable() {
    const toast = useRef(null);
    const orderedProducts = useSelector(state => state.orders.orderDetails);
    const alloffers = useSelector(state => state.offers.offers);
    const [ordersDetails,setOrdersDetails] = useState({})
    const search = useSelector((state) => state.offers.offerSearch);
    const loading  = useSelector(state => state.offers.loading);
    const inventory = useSelector(state => state.inventory.inventory)
    const getOffers = useGetOffers()
    const dispatch = useDispatch()
    const formatDate = useDateformate()
    const [updatedoffers, setUpdatedOffers] = useState({})

     // Add this line to fix the error:
    const user_role = localStorage.getItem('role');
    

    useEffect(()=>{
        setOrdersDetails(orderedProducts)
    },[orderedProducts])
    console.log(orderedProducts)
    let serialNo = 1
    const calculateItemPrice = (price, tax) => {
        const txRemovePrice = (parseFloat(price) * parseFloat(tax)) / 100;
        const itemPrice = parseFloat(price) - parseFloat(txRemovePrice);
        return itemPrice.toFixed(2); // Returns a string rounded to 2 decimal places
    };
    console.log(search)


 useEffect(()=>{
         const newcategory = alloffers?.map(obj2=>{
             const matchedValues =[]
             obj2?.inventory_list?.forEach(key=>{
             const match = inventory.find(obj1=>obj1.value===key)
             if (match){
                 matchedValues.push(match.name)
             }
         })
         return {...obj2, inventory_name:matchedValues}
         })
         console.log(newcategory)
         setUpdatedOffers(newcategory)
     }, [inventory, alloffers])
  const accept = async (id) => {
    console.log(id)
    await CustomAxios.delete(`offers/delete/${id}`, {
    }).then(res => {
        getOffers()
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Offer Deleted Successfully', life: 3000 });
    }).catch(err => { console.log(err) });
  }
  console.log(updatedoffers)
  const confirmDelete = (item) => {
    confirmDialog({
      message: (
        <Box sx={{ display: "flex", gap: "10px",flexDirection:"column" }}>
          <Box sx={{ display: "flex", gap: "20px",alignItems:"center" }}>
            <Box >{item.offer_name}</Box>
          </Box>
          <Typography sx={{fontSize:"16px",fontWeight:500}}>Do you want to delete this Offer </Typography>
        </Box>
      ),
      header: 'Delete Confirmation',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-danger',
      accept: () => accept(item.offer_id),
    });
  };
   const handleOpen = (row) => {
    console.log(row)
    dispatch(updateOfferDetail(row))
    dispatch(updateOfferModal(true))
    dispatch(updateOfferEdit(true))
  };
    return (<Box>
        <Toast ref={toast} />
        <ConfirmDialog />
        <TableContainer >
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Hubs</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Offer Name</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Offer product</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Offer Description</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Status</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Start date</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">End date</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Created on</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Total Units</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Available Units</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Min spent</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Edit / Delete</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {updatedoffers?.length>0?
            updatedoffers?.filter((item) => {
            if (!item.offer_name) return false;

            return search !== ""
            ? item.offer_name.toLowerCase().includes(search?.toLowerCase())
            : true; }).map((item,ind) => {
                    return (<> {
                            <TableRow key={item.id} >
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{serialNo++}</TableCell>
                                <TableCell sx={{textAlign: "left", textTransform: "capitalize", backgroundColor: "white"}}>{item.inventory_name?.map(inv => inv).join(', ')}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.offer_name}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                                <Box sx={{display:"flex",gap:"10px",alignItems:"center"}}>
                                    {item.offer_products?.images.map((img) => (<Box component='img' src={img} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px" }}></Box>))}
                                    {item.offer_products.item_name}</Box></TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.offer_description}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.is_active?"Active":"Inactive"}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{formatDate(item.start_date)}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{formatDate(item.end_date)}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{formatDate(item.created_on)}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.total_quantity}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.available_quantity}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.min_spent}</TableCell>
                                
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                                    <Box sx={{ display: "flex", gap: "8px", alignItems: "center",height:"100%" }}>
                                        <Tooltip title="Edit" arrow>
                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(item)}> 
                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}> Edit
                                                </Typography>
                                            </Button>
                                        </Tooltip>
                                        {/* Only show delete for super_admin */}
                                        {user_role === 'super_admin' && (
                                            <Tooltip title="Delete" arrow>
                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}> 
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}> Delete
                                                    </Typography>
                                                </Button>
                                            </Tooltip>
                                        )}
                                    </Box>
                                        
                                    </TableCell>

                            </TableRow>}</>)
            })
            : <TableRow  >
            {loading?<TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white",height:"200px",fontWeight:"700" }} colSpan={12}>
                <Box>
                    <Box sx={{ width: "80%" }}>
                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                    </Box>
                    <Box sx={{ width: "80%" }}>
                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                    </Box>
                    <Box sx={{ width: "80%" }}>
                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                    </Box>
                </Box>
            </TableCell>:
            <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white",height:"200px",fontWeight:"700" }} colSpan={12}>No Offers Available</TableCell>}
        </TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}